import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  ProductNameNinValidationErrorType,
  ProductNameNinValidationRequest,
  ValidateProductNameNinState,
} from "./interfaces";

const validateProductNameNinSlice = createSlice({
  name: "validateProductNameNin",
  initialState: {} as ValidateProductNameNinState,
  reducers: {
    initializeValidatedProductNameNin: (
      state: ValidateProductNameNinState,
      action: PayloadAction<ProductNameNinValidationRequest>,
    ) => {
      const { productId, personInfo } = action.payload;
      state[productId] = {
        personInfo,
        isLoading: false,
        error: undefined,
      };
    },
    validateProductNameNinStart: (
      state: ValidateProductNameNinState,
      action: PayloadAction<ProductNameNinValidationRequest>,
    ) => {
      const {
        payload: { productId, personInfo },
      } = action;
      state[productId] = {
        personInfo,
        isLoading: true,
        error: undefined,
      };
    },
    validateProductNameNinSucceded: (
      state: ValidateProductNameNinState,
      action: PayloadAction<string>,
    ) => {
      const productId = action.payload;
      state[productId].isLoading = false;
      state[productId].error = undefined;
    },
    validateProductNameNinError: (
      state: ValidateProductNameNinState,
      action: PayloadAction<{
        productId: string;
        error: ProductNameNinValidationErrorType;
      }>,
    ) => {
      const {
        payload: { productId, error },
      } = action;
      state[productId].isLoading = false;
      state[productId].error = error;
    },
  },
});

export const {
  initializeValidatedProductNameNin,
  validateProductNameNinStart,
  validateProductNameNinSucceded,
  validateProductNameNinError,
} = validateProductNameNinSlice.actions;
export const validatedProductNameNin = validateProductNameNinSlice.reducer;
